export class MessageTemplateService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    get({ limit, before, after, templateName, status, renewCache, }) {
        const query = this.buildQuery({ limit, before, after, templateName, status, renewCache });
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@wa.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/message-templates${query}`,
        });
    }
    getCacheManaged({ limit, before, after, templateName, status, renewCache, }) {
        const query = this.buildQuery({ limit, before, after, templateName, status, renewCache });
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@wa.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/message-templates-cache-managed${query}`,
        });
    }
    getMessagesTemplatesEnriched({ limit, before, after, templateName, status, renewCache, }) {
        const query = this.buildQuery({ limit, before, after, templateName, status, renewCache });
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@wa.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/message-templates-enriched${query}`,
        });
    }
    buildQuery({ limit, before, after, templateName, status, renewCache }) {
        const params = new URLSearchParams();
        if (limit) {
            params.append('limit', String(limit));
        }
        if (before) {
            params.append('before', before);
        }
        if (after) {
            params.append('after', after);
        }
        if (templateName) {
            params.append('templateName', templateName);
        }
        if (status) {
            params.append('status', status);
        }
        if (renewCache) {
            params.append('renewCache', 'true');
        }
        const queryString = params.toString();
        return queryString ? `?${queryString}` : '';
    }
    getWABAInformation() {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            to: `postmaster@wa.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/whatsapp-business-account',
        });
    }
    set(messageTemplate) {
        return this.MessagingHubService.sendCommand({
            method: 'set',
            type: 'application/json',
            to: `postmaster@wa.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/message-templates',
            resource: messageTemplate,
        });
    }
    async uploadAttachment(messageTemplate) {
        return this.MessagingHubService.processCommand({
            method: 'set',
            type: 'application/vnd.lime.media-link+json',
            to: `postmaster@wa.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/message-templates-attachment',
            resource: messageTemplate,
        });
    }
    async uploadAttachmentV2(messageType) {
        return this.MessagingHubService.processCommand({
            method: 'set',
            type: 'application/json',
            to: `postmaster@wa.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/message-templates-attachment/v2',
            resource: messageType,
        });
    }
    async getUploadProgess(uploadSessionId) {
        return this.MessagingHubService.processCommand({
            method: 'get',
            to: `postmaster@wa.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/message-templates-attachment-status',
            resource: uploadSessionId,
        });
    }
    delete(messageTemplateName) {
        return this.MessagingHubService.sendCommand({
            method: 'delete',
            to: `postmaster@wa.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: `/message-templates/${messageTemplateName}`,
        });
    }
    async getEvaluateMessage(message, type) {
        const commandResponse = await this.MessagingHubService.processCommand({
            method: 'set',
            to: `postmaster@wa.gw.${this.MESSAGINGHUBDOMAIN}`,
            uri: '/message-templates-validate',
            type: 'application/vnd.iris.whatsapp.message-templates-validate-resource+json',
            resource: {
                templateText: message,
                templateType: type,
            },
        });
        const { resource } = this.MessagingHubService.ensureCommandSuccess(commandResponse);
        return resource;
    }
}
MessageTemplateService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN'];
